import { Injectable, Component, OnInit,ViewContainerRef } from '@angular/core';
import { Router,  ActivatedRoute, Params} from '@angular/router';;
import { ToastrService } from 'ngx-toastr';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import {Subscription} from 'rxjs';
import { GlobalEventMangerService } from '../global-event-manger.service';

import { LocalstorageService } from '../localstorage.service';
import { EchexpaymentService } from '../echexpayment.service';
import { UserService } from '../user.service';
import { Helper } from '../helpers/helper';

@Component({
  selector: 'echexpayment-checkprinted',
  templateUrl: './sendcheckprinted.component.html',
  styleUrls: ['./sendcheck.component.css']
})
export class SendcheckprintedComponent implements OnInit {
	public merchantImg_url: string;
	constructor(protected localStorageService: LocalstorageService,) { 
		let userDetails = <any>{};
		let Business_image = <any>{};
		userDetails = this.localStorageService.getData("currentUser");
		Business_image = this.localStorageService.getData("Mer_Profile_image");
		this.merchantImg_url = Business_image ? Business_image.business_image_url : (userDetails && userDetails.business_image_url);
		
	}

	ngOnInit() {
		
	}
	
	
	
	
	

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/sendcheck/sendcheckprinted.component.ts